export default __webpack_public_path__ + "static/media/error.9107e493.svg";